import { render, staticRenderFns } from "./reportLabelAnnotationItem.vue?vue&type=template&id=b85ed1c8&scoped=true"
import script from "./reportLabelAnnotationItem.vue?vue&type=script&lang=js"
export * from "./reportLabelAnnotationItem.vue?vue&type=script&lang=js"
import style0 from "./reportLabelAnnotationItem.vue?vue&type=style&index=0&id=b85ed1c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85ed1c8",
  null
  
)

export default component.exports